const getPaletteColor = (color) => {
    return new Promise((resolve) => {
        window?.opr?.palette?.getColorHSL(color, ({ h, s, l }) => {
            resolve({ h, s, l });
        });
    });
};
const getPaletteKeys = () => {
    return new Promise((resolve) => {
        window?.opr?.palette?.getPalette(resolve);
    });
};
export default {
    async getPalette() {
        const keys = await getPaletteKeys();
        const pairs = await Promise.all(keys.map(async (key) => [key, await getPaletteColor(key)]));
        return Object.fromEntries(pairs);
    },
    addListener(handler) {
        window?.opr?.palette?.onPaletteChanged.addListener(handler);
    },
    removeListener(handler) {
        window?.opr?.palette?.onPaletteChanged.removeListener(handler);
    },
};
